import { companyApiRoute } from '@crm/shared/api';

import type { TDeal } from '../model/deal';

export const dealApiRoutes = {
    changeDealColumnRoute: () => companyApiRoute('crm-process-queue'),
    deleteDealRoute: (dealId: TDeal['id']) => companyApiRoute(`crm/deal/${dealId}`),
    getDealDetailsRoute: (dealId: TDeal['id']) => companyApiRoute(`crm/deal/${dealId}`),
    updateDealDetailsRoute: (dealId: TDeal['id']) => companyApiRoute(`crm/deal/${dealId}`),
    getDealTasksRoute: (dealId: TDeal['id']) => companyApiRoute(`crm/deal/${dealId}/tasks`),
    createDealTaskRoute: (dealId: TDeal['id']) => companyApiRoute(`crm/deal/${dealId}/tasks`),
    setDealTaskCompletedRoute: (dealId: TDeal['id'], taskUid: string) =>
        companyApiRoute(`crm/deal/${dealId}/tasks/${taskUid}/set-is-completed`),
    switchDealTaskStatusRoute: (dealId: TDeal['id'], taskUid: string) =>
        companyApiRoute(`crm/deal/${dealId}/tasks/${taskUid}/switch-status`),
    updateDealTaskRoute: (dealId: TDeal['id'], taskUid: string) =>
        companyApiRoute(`crm/deal/${dealId}/tasks/${taskUid}/update`),
    deleteDealTaskRoute: (dealId: TDeal['id'], taskUid: string) =>
        companyApiRoute(`crm/deal/${dealId}/tasks/${taskUid}`),
    createDealCommentRoute: (dealId: TDeal['id']) =>
        companyApiRoute(`crm/deal/${dealId}/comments`),
    pollDealCommentsRoute: (dealId: TDeal['id']) =>
        companyApiRoute(`crm/deal/${dealId}/comments/poll`),
    deleteDealCommentRoute: (dealId: TDeal['id'], commentId: number | string) =>
        companyApiRoute(`crm/deal/${dealId}/comments/${commentId}`),
    lostDealsRoute: () => companyApiRoute('crm/deals/lost'),
    postponeDealsRoute: () => companyApiRoute('crm/deals/postponed'),
    returnDealsToBoardRoute: () => companyApiRoute(`crm/deals/return-to-board`),
    getPostponedDealsRoute: () => companyApiRoute('crm/deals/postponed'),
    updatePostponedDealRoute: (dealId: TDeal['id']) =>
        companyApiRoute(`crm/deal/${dealId}/postponed`),
    getLostDealsRoute: () => companyApiRoute('crm/deals/lost'),
    updateLostDealRoute: (dealId: TDeal['id']) => companyApiRoute(`crm/deal/${dealId}/lost`),
    getInWorkOrFinishedDealsRoute: () => companyApiRoute('crm/deals/in-work-or-finished'),
    updateInWorkOrFinishedDealRoute: (dealId: TDeal['id']) =>
        companyApiRoute(`crm/deal/${dealId}/in-work-or-finished`),
    markDealInWorkOrFinished: () =>
        companyApiRoute(`crm/deals/in-work-or-finished`),
};
